import React from 'react';
import { Root } from './styles';

const Logo: React.FC = ({}) => {
  return <Root variant="h2">KonBeO</Root>;
};

export default Logo;
